import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const LIST_CONTENT_BLOCKER_SYMBOL = Symbol();
const useListContentBlocker = ()=>useImmutableContext(LIST_CONTENT_BLOCKER_SYMBOL);
const useListContentBlockerProvider = (...args)=>useImmutableContextProvider(LIST_CONTENT_BLOCKER_SYMBOL, ...args);
export { useListContentBlocker, useListContentBlockerProvider };
